module.exports = __webpack_public_path__ + "media/images/dd-arrow-4f8a6247.png";